import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist';

import { ReqUserSetting } from '@/apis/setting/type';
import { RoutePaths } from '@/layouts/config/routes';

import { ResMenuVO, ResResourceVO, ResSettingInfo, ResDefaultInitPageVO } from '../../apis/auth/type';

export interface LoginUserInfoState {
  menus: ResMenuVO[];
  resources: ResResourceVO[];
  defaultPage: RoutePaths;
  defaultPageMenuName: string | undefined;
  eat: string | undefined;
  eatName: string | undefined;
  userId: string | undefined;
  userSettingInfo: ResSettingInfo;
  fingerprint: string | undefined;
  userCateCode: string;
}

const loginUserInfoInitState: LoginUserInfoState = {
  menus: [],
  resources: [],
  defaultPage: '/',
  defaultPageMenuName: undefined,
  eat: undefined,
  eatName: undefined,
  userId: undefined,
  userSettingInfo: { id: '', rowsPerPage: '', reportPeriodPreset: 'CALENDAR_LAST_MONTH' },
  fingerprint: undefined,
  userCateCode: '',
};

const loginUserInfoSlice = createSlice({
  name: 'loginUserInfo',
  initialState: loginUserInfoInitState,
  reducers: {
    onMenuCreated: (state, action: PayloadAction<ResMenuVO[]>) => {
      const temp = state;
      temp.menus = action.payload;
      return temp;
    },
    onResourceCreated: (state, action: PayloadAction<ResResourceVO[]>) => {
      const temp = state;
      temp.resources = action.payload;
      return temp;
    },
    onEatCreated: (state, action: PayloadAction<{ eat: string; eatName: string }>) => {
      const temp = state;
      temp.eat = action.payload.eat;
      temp.eatName = action.payload.eatName;
      return temp;
    },
    onUserIdCreated: (state, action: PayloadAction<string>) => {
      const temp = state;
      temp.userId = action.payload;
      return temp;
    },
    onSettingInfoCreated: (state, action: PayloadAction<ResSettingInfo>) => {
      const temp = state;
      temp.userSettingInfo = action.payload;
      if (action.payload.rowsPerPage === null) {
        temp.userSettingInfo.rowsPerPage = '5';
      }
      if (!action.payload.reportPeriodPreset) {
        temp.userSettingInfo.reportPeriodPreset = 'CALENDAR_LAST_MONTH';
      }
      return temp;
    },
    onSettingInfoChange: (state, action: PayloadAction<ReqUserSetting>) => {
      const temp = state;
      temp.userSettingInfo = action.payload;
      return temp;
    },
    onFingerprintUpdated: (state, action: PayloadAction<string>) => {
      const temp = state;
      temp.fingerprint = action.payload;
      return temp;
    },
    onDefaultPageCreated: (state, action: PayloadAction<ResDefaultInitPageVO | null>) => {
      const temp = state;
      if (action.payload) {
        temp.defaultPage = action.payload.routeInfo;
        temp.defaultPageMenuName = action.payload.menuName;
      }
      return temp;
    },
    onUserCateCodeCreated: (state, action: PayloadAction<string>) => {
      const temp = state;
      temp.userCateCode = action.payload;
      return temp;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => loginUserInfoInitState);
  },
});

export const {
  onMenuCreated,
  onResourceCreated,
  onEatCreated,
  onUserIdCreated,
  onSettingInfoCreated,
  onFingerprintUpdated,
  onSettingInfoChange,
  onDefaultPageCreated,
  onUserCateCodeCreated,
} = loginUserInfoSlice.actions;

export default loginUserInfoSlice;
